import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, ExternalLink } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { useI18n } from "../i18n/I18nContext";
import { api } from "../lib/nailApi";

export default function SpeakersDirectoryPage() {
  const { lang } = useI18n();
  const [speakers, setSpeakers] = useState([]);
  useEffect(() => { api.get("/speakers/list").then((r) => setSpeakers(r.data.speakers || [])).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-white text-charcoal" data-testid="speakers-page">
      <SiteHeader variant="light" />
      <main className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <p className="text-[11px] uppercase tracking-[0.32em] text-emerald2 font-semibold mb-5">{lang === "en" ? "Speaker directory" : "Danh mục diễn giả"}</p>
        <h1 className="font-serif text-5xl md:text-6xl text-charcoal">{lang === "en" ? "Speakers" : "Diễn Giả"}</h1>
        <p className="mt-4 text-warmgray-700 max-w-2xl">{lang === "en" ? "Industry leaders, educators, and salon owners sharing knowledge with the Nail Viet Club community." : "Lãnh đạo ngành, chuyên gia đào tạo và chủ tiệm đang chia sẻ kiến thức với cộng đồng Nail Viet Club."}</p>

        {speakers.length === 0 ? (
          <div className="mt-12 bg-warmgray-50 border border-dashed border-warmgray-300 rounded-3xl p-12 text-center text-warmgray-700">
            {lang === "en" ? "Speaker directory is growing. Check back soon." : "Danh mục đang được cập nhật. Vui lòng quay lại sau."}
          </div>
        ) : (
          <div className="mt-12 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
            {speakers.map((sp, i) => (
              <div key={i} className="bg-white border border-warmgray-200 rounded-3xl overflow-hidden hover:-translate-y-0.5 hover:shadow-[0_18px_40px_-20px_rgba(14,91,79,0.18)] transition-all" data-testid={`directory-speaker-${i}`}>
                <div className="aspect-[4/5] bg-warmgray-100 overflow-hidden">
                  {sp.photo_url ? <img src={sp.photo_url} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center text-warmgray-500 font-serif text-4xl">{sp.full_name?.[0]}</div>}
                </div>
                <div className="p-5">
                  <div className="font-serif text-xl text-charcoal flex items-center gap-1.5">
                    {sp.full_name}
                    {sp.is_featured && <Star className="w-3.5 h-3.5 text-gold-500" />}
                  </div>
                  <div className="text-xs text-warmgray-700 mt-1 truncate">{[sp.title, sp.company].filter(Boolean).join(" · ")}</div>
                  {sp.topic && <div className="mt-2 text-sm text-emerald2 font-medium">{sp.topic}</div>}
                  {sp.events?.length > 0 && (
                    <div className="mt-3 flex flex-wrap gap-1.5">
                      {sp.events.slice(0, 2).map((ev) => (
                        <Link key={ev.slug} to={`/events/${ev.slug}`} className="text-[10px] uppercase tracking-[0.18em] text-warmgray-700 border border-warmgray-300 rounded-full px-2 py-0.5 hover:text-emerald2 hover:border-emerald2 inline-flex items-center gap-1">
                          {ev.name?.slice(0, 28)} <ExternalLink className="w-2.5 h-2.5" />
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
